export default {"src":"/_next/static/media/fintech.5ee4845e.svg","height":48,"width":50,"blurWidth":0,"blurHeight":0};